var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full text-base-content"},[_c('div',[_vm._v("Configuration")]),_c('div',{staticClass:"flex justify-end mb-6"})])
}]

export { render, staticRenderFns }